import * as React from 'react'

import { ProductPageData } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPage'
// import { Variant } from '@thg-commerce/enterprise-components/src/transformer/productOptionsTransformer'
import { SwatchShape } from '@thg-commerce/gravity-elements/Swatch/types'

import {
  OutOfStockNotificationRenderer,
  ProductOptionSelectorRenderer,
} from '../../../src/renderers'
import { useReviewsPage } from '../../context'

export const ProductOptions = () => {
  const {
    product,
    selectedVariant,
    setSelectedVariant,
    options,
  } = useReviewsPage()

  const variantChangedCallback = (variant: ProductPageData['variants'][0]) => {
    setSelectedVariant && setSelectedVariant(variant)
  }

  return (
    <React.Fragment>
      <ProductOptionSelectorRenderer
        product={product}
        swatchShape={SwatchShape.CIRCLE}
        variantChangedCallback={variantChangedCallback}
        options={options || []}
        selectedVariant={selectedVariant}
        variants={product?.variants || []}
        masterProductSku={product?.sku}
        initialSelectedOptions={product?.selectedOptions}
        sortedOptionKeys={product?.sortedOptionKeys}
        defaultProductOptions={product?.defaultProductOptions}
        forceDropDowns={false}
        notifyWhenInStock={product?.hasVariantsWithNotifyWhenInStockEnabled}
        queryFullVariantData={true}
      />
      <OutOfStockNotificationRenderer
        selectedVariant={selectedVariant}
        url={product?.url}
      />
    </React.Fragment>
  )
}
